export function setColor(theme, colorVariant, defaultColorVariant) {
    // TODO: Find a better way of passing the theme around with Styled Components.
    if (theme) {
        var themeColorPair = theme === null || theme === void 0 ? void 0 : theme.color;
        var lookup = colorVariant || defaultColorVariant;
        switch (lookup) {
            case 'alert':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.alert.background;
            case 'dark':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.dark.background;
            case 'highlight':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.highlight.background;
            case 'light':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.light.background;
            case 'primary':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.primary.background;
            case 'secondary':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.secondary.background;
            case 'tertiary':
                return themeColorPair === null || themeColorPair === void 0 ? void 0 : themeColorPair.tertiary.background;
            default:
                return colorVariant || 'Hotpink';
        }
    }
    return 'Hotpink';
}
//# sourceMappingURL=icon.utilities.js.map